const fileFormat = Object.freeze({
  images: 'image/*',
  email: '.msg,message/rfc822',
  csv: '.csv',
  all: '*',
});

export default fileFormat;
